/**
 * 表达式解析器
 * 负责解析 this.xxx 引用
 */

import type { DataObject, DataValue, GetDataFn } from "../types";

/**
 * 解析表达式中的 this.xxx 引用
 */
export class ExpressionParser {
  /**
   * 解析 this.xxx 引用，返回替换后的表达式
   * @param expr 原始表达式
   * @param getData 获取数据的函数
   */
  resolveReferences(expr: string, getData: GetDataFn): string {
    // 匹配变量引用 (this.xxx, $scope.xxx, or bare variable)
    // 避免匹配字符串字面量需要更复杂的解析，这里简化处理
    // 假设表达式中没有复杂的字符串包含类似变量的模式
    return expr.replace(/([a-zA-Z_$][a-zA-Z0-9_$.]*)/g, (match) => {
      // 排除字面量
      if (
        match === "true" ||
        match === "false" ||
        match === "null" ||
        match === "undefined"
      ) {
        return match;
      }
      // 排除数字
      if (!isNaN(Number(match)) && !isNaN(parseFloat(match))) {
        return match;
      }

      const val = getData(match);
      if (typeof val === "string") {
        return JSON.stringify(val);
      }
      if (val === undefined) {
        return "undefined";
      }
      if (val === null) {
        return "null";
      }
      if (typeof val === "boolean" || typeof val === "number") {
        return String(val);
      }
      return JSON.stringify(val);
    });
  }

  /**
   * 从嵌套数据对象中获取值
   * @param data 数据对象
   * @param key 点分隔的键路径，如 "user.name"
   */
  getNestedValue(data: DataObject, key: string): DataValue | undefined {
    const keys = key.split(".");
    let value: DataValue = data;
    for (const k of keys) {
      if (
        value != undefined &&
        typeof value === "object" &&
        !Array.isArray(value) &&
        k in value
      ) {
        value = (value as DataObject)[k];
      } else {
        return undefined;
      }
    }
    return value;
  }
}
